import React from 'react';
import dynamic from 'next/dynamic';
import withMainLayout from 'layouts/main';
import {createTranslator} from 'next-intl';
import {pageMessagesProps} from 'helpers/i18n';
import AboutTop from '@/content/about/top-section';
import shared from '../messages/en/shared.json';
import about from '../messages/en/about.json';

// Content sections & dynamic imports

const WhatWeDo = dynamic(() => import('@/content/about/what-we-do'), {
  loading: () => null
});

const WhoWeHelp = dynamic(() => import('@/content/about/who-we-help'), {
  loading: () => null
});

const WhoWeAre = dynamic(() => import('@/content/about/who-we-are'), {
  loading: () => null
});

const WorkWithUs = dynamic(() => import('@/content/about/work-with-us'), {
  loading: () => null
});

const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const AboutPage = () => (
  <>
    <AboutTop />
    <WhatWeDo />
    <WhoWeHelp />
    <WhoWeAre />
    <WorkWithUs />
    <PreFooter />
  </>
);

const seoMetas = props => {
  const seoT = createTranslator({locale: props.locale, messages: props.messages});
  return {
    title: seoT('about.seo.title'),
    description: seoT('about.seo.description'),
    canonical: seoT('about.seo.canonical')
  };
};

export default withMainLayout(AboutPage, seoMetas);

export const messagesForIntl = {shared, about};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}
